module.exports = __webpack_public_path__ + "img/illusionaryGhosts.8edf19cd.jpg";